import Cloud from '../../../../../icons/cloud.svg?react';
import wifi from '../../../../../icons/wifi.svg?react';
import internet from '../../../../../icons/internet.svg?react';

export default function UniversalLifeArticleData() {
    return {
  Title :"Your information is always private",
  subtitle:"We strive to be worthy of protecting your private information. In all of our processes we reduce the amount of information you have to enter, both to protect your privacy and to keep the process simple. The information you do give us is only shared with parties who require it to complete your quotes and product applications.",
  steps:[
        {
            title: "Defense-In-Depth",
            icon : Cloud,
            paragraph: "Every part of the application is secure. From the perimeter, to the application, to the people in our organization who receive regular security training, we protect your data in every moving part of the process."
        },
        {
          title: "Security Monitoring & Testing",
          icon : wifi,
          paragraph: "Our network is regularly tested and actively monitored by a team of security professionals 24x7x365 periodically to ensure our ability to keep your information safe in the face of ever-changing threats."
        },
        {
          title: "End-To-End Encryption",
          icon : internet,
          paragraph: "All of your data, whether moving over the internet or resting on a server, is secured with military-grade AES 256-bit encryption."
        },
    ]
   };
 }
